module.exports = __webpack_public_path__ + "img/pattern3.f8d63a9.svg";